import { IAppState } from '../../redux';
import { IAuctionServiceCost } from '../../redux/reducers';
import { selectActiveService } from '../publishTerms';

export function selectCurrentServiceCost(state: IAppState): IAuctionServiceCost | null {
  const {
    auction: { serviceCosts },
  } = state;

  const currentService = selectActiveService(state);

  if (!currentService) {
    return null;
  }

  const currentServiceCost = serviceCosts.find(({ serviceTypes }) =>
    serviceTypes.some(serviceType => currentService.services.includes(serviceType)),
  );

  return currentServiceCost || null;
}
